import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { IndianRupee, Clock, Users } from 'lucide-react';

export const CSRProposalCard = ({ pp }) => (
    <Card className="h-full overflow-hidden bg-card border-border card-lift">
        {pp.image_url && (
            <div className="aspect-[16/9] overflow-hidden bg-muted">
                <img
                    src={pp.image_url}
                    alt={pp.title}
                    loading="lazy"
                    className="w-full h-full object-cover"
                />
            </div>
        )}
        <CardContent className="p-5">
            <div className="flex items-center gap-2 mb-2 flex-wrap">
                <Badge variant="outline" className="text-[10px]">
                    Proposal
                </Badge>
                <Badge variant="outline" className="text-[10px]">
                    {pp.category}
                </Badge>
            </div>
            <div className="font-display font-semibold text-lg leading-snug mb-1">
                {pp.title}
            </div>
            <p className="text-sm text-muted-foreground line-clamp-3">{pp.summary}</p>
            <div className="mt-3 grid grid-cols-3 gap-2 text-[11px]">
                {pp.budget && (
                    <div className="flex items-center gap-1 text-foreground/85">
                        <IndianRupee className="h-3 w-3 text-[hsl(var(--accent))]" />
                        {pp.budget}
                    </div>
                )}
                {pp.timeline && (
                    <div className="flex items-center gap-1 text-foreground/85">
                        <Clock className="h-3 w-3 text-[hsl(var(--accent))]" />
                        {pp.timeline}
                    </div>
                )}
                {pp.beneficiaries && (
                    <div className="flex items-center gap-1 text-foreground/85 truncate">
                        <Users className="h-3 w-3 text-[hsl(var(--accent))]" />
                        {pp.beneficiaries}
                    </div>
                )}
            </div>
        </CardContent>
    </Card>
);

export default CSRProposalCard;
